/* Copyright (c) 2021-2026, NVIDIA CORPORATION.  All rights reserved.
*
* NVIDIA CORPORATION and its licensors retain all intellectual property
* and proprietary rights in and to this software, related documentation
* and any modifications thereto.  Any use, reproduction, disclosure or
* distribution of this software and related documentation without an express
* license agreement from NVIDIA CORPORATION is strictly prohibited.
*/

/** This file was automatically generated. DO NOT MODIFY IT BY HAND. */

/* eslint-disable @typescript-eslint/naming-convention */

import { BridgeCommands } from '../../../src/bridge.commands';

import { Types } from '../../types/index';

/** This object was automatically generated by generate-commands. DO NOT MODIFY IT BY HAND. */

const Pop: BridgeCommands.Command<
    {},
    Types.Common.Ipc.IpcMessage
    > = {
    legacyCommand: 'QUERY_IPC_POP_MESSAGE',
    system: 'CrimsonNative',
    module: 'Ipc',
    method: 'Pop',
    persistent: false
};

/** This object was automatically generated by generate-commands. DO NOT MODIFY IT BY HAND. */

const Push: BridgeCommands.Command<
    Types.Common.Ipc.PushParameters,
    string
    > = {
    legacyCommand: 'QUERY_IPC_PUSH_MESSAGE',
    system: 'CrimsonNative',
    module: 'Ipc',
    method: 'Push',
    persistent: false
};

/** This object was automatically generated by generate-commands. DO NOT MODIFY IT BY HAND. */

const LoginStatus: BridgeCommands.Command<
    Types.Common.Ipc.LoginStatusParameters,
    any
    > = {
    legacyCommand: 'QUERY_GFN_LOGIN_STATUS',
    system: 'CrimsonNative',
    module: 'Ipc',
    method: 'LoginStatus',
    persistent: false
};

/** This object was automatically generated by generate-commands. DO NOT MODIFY IT BY HAND. */

const EulaAccepted: BridgeCommands.Command<
    Types.Common.Ipc.EulaAcceptedParameters,
    any
    > = {
    legacyCommand: 'QUERY_GFN_EULA_ACCEPTED',
    system: 'CrimsonNative',
    module: 'Ipc',
    method: 'EulaAccepted',
    persistent: false
};

export const Ipc = {
Pop,
Push,
LoginStatus,
EulaAccepted
};
